// extracted by mini-css-extract-plugin
export default {"icon":"HeaderInfoButton_icon__Hr7pr","badge":"HeaderInfoButton_badge__LANja","bump":"HeaderInfoButton_bump__W8HHj"};